<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="ded">
<p class="center">For Iain Mackay and his sister,<br/>Mrs. Barbara Macleod…<br/>the best holiday-makers in Beauly.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795319587_epub_ded_r1.vue?bd44e966